/**
 * assets/viveria-prelander.js
 * Shows the sticky bottom CTA bar once the visitor scrolls past the
 * main offer box, and hides it again near the very top of the page.
 * No dependencies. Safe to load with `defer`.
 */
(function () {
  function init() {
    var stickyBar = document.querySelector('[data-viveria-sticky-bar]');
    var offerBox = document.querySelector('[data-viveria-offer]');

    if (!stickyBar || !offerBox) return;

    var showAfter = offerBox.offsetTop + offerBox.offsetHeight;

    function onScroll() {
      if (window.scrollY > showAfter) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
